

/*
 *   File : mandates.js
 *   Author URI : www.evoqins.com
 *   Description : Page to show all available and mandates created by Super Admin.
 *   Integrations : null
 *   Version : v1.0
 *   Created : 17-01-2024
 */

import { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import Cookies from 'js-cookie';

import { GradientButton } from "../../Component/CTA";
import Color from "../../Styles/color.module.scss"
import { CustomLoader, EmptyScreen } from "../../Component/Other";
import Footer from "../../Component/Footer/footer";
import { CustomTab } from "../../Component/Tab";
import { DarkModeContext } from "../../Context/dark-mode-context";

import OrderAPIService from "../../Service/order-api";
import { Icon } from "../../Component/Icon";
import { UploadSignedMandate } from "../../Component/Modal";
import APIService from "../../Service/api-service";
import { Modal } from "bootstrap";

const MANDATE_TYPE = ['E-mandate', 'Physical mandate'];

export default function Mandates() {

    var timer;
    const { darkMode } = useContext(DarkModeContext);
    const [apiLoader, setApiLoader] = useState(true);
    const [mandateList, setMandateList] = useState(null);
    console.log('mandateList', mandateList);
    const [physicalMandate, setPhysicalMandate] = useState({});
    console.log('physicalMandate', physicalMandate);

    const [showInvalidUserScreen, setShowInvalidUserScreen] = useState(false);
    const [invalidScreenDesc, setInvalidScreenDesc] = useState('');
    const [invalidScreenTitle, setInvalidScreenTitle] = useState('');
    const [buttonLoader, setButtonLoader] = useState(false);
    const [mandateType, setMandateType] = useState(null);
    const [openUploadDocModal, setOpenUploadDocModal] = useState(false);
    const [selectedMandate, setSelectedMandate] = useState("");
    const [loader, setLoader] = useState(false);
    const [bankData, setBankData] = useState([]);
    // const [viewMandates, setViewMandates] = useState(null);
    // const [tabIndex, setTabIndex] = useState(1);



    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    useEffect(() => {
        if (openUploadDocModal === true) {
            const modal = new Modal(document.getElementById("upload-mandate"), {});
            modal.toggle();
        }
    }, [openUploadDocModal]);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const typeFromUrl = params.get('mandate_type');

        if (typeFromUrl === '1' || typeFromUrl === '2') {
            setMandateType(Number(typeFromUrl));
        } else {
            setMandateType(1); // default fallback
        }
    }, []);


    useEffect(() => {
        if (mandateType !== null) {
            _getMandates();
        }
    }, [mandateType]);

    // redirect user based on login status
    function _redirectUser() {
        let login_status = Cookies.get('refreshToken');
        if (login_status) {
            window.location.href = '/';
        } else {
            window.location.href = process.env.REACT_APP_LANDING_PAGE_URL;
        }
    }

    function _openMandateUrl(url) {

        var new_window;

        new_window = window.open(url, '_blank', 'width=800,height=800');

        if (new_window !== null) {
            new_window.opener = null;
            timer = setInterval(function () {
                if (new_window.closed) {
                    clearInterval(timer);
                    _mandateCallback();
                }
            }, 1000);
        } else {
            setApiLoader(false);
            toast.dismiss();
            toast.error('Popups are disabled in your browser. Please allow popups to open the payment gateway.', {
                type: 'error'
            });
        }

    }

    // Call back mandate authentication
    function _mandateCallback() {
        let url = 'profile/mandates/callback';
        let payload = JSON.stringify({
            mandate_id: mandateList.mandate_id
        });
        OrderAPIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                if (response.data.status === true) {
                    toast.success('Mandate Approved successfully', {
                        type: 'success'
                    });
                } else {
                    toast.error('Mandate is pending', {
                        type: 'error'
                    });
                }

                _getMandates();
            } else {
                toast.error(response.message, {
                    type: 'error'
                });
            }
        })
        setButtonLoader(false);

    }

    function _handleMandateType(value) {
        setMandateType(value);
    }

    // API - get mandates
    function _getMandates() {
        let url = `profile/mandates/pending-mandate?mandate_type=${mandateType}`;
        OrderAPIService(false, url).then((response) => {
            if (response.status_code === 200) {
                if (mandateType === 1) {
                    setMandateList(response.data);
                } else {
                    setPhysicalMandate(response.data)
                }
            } else {
                setShowInvalidUserScreen(true);
                setInvalidScreenTitle('No data found');
                setInvalidScreenDesc('No mandates found at the moment');
                setTimeout(() => {
                    _redirectUser();
                }, 3000);
            }
            setApiLoader(false);
        })
    };

    // API - authenticate mandate
    function _authMandate() {
        setButtonLoader(true);
        let url = 'profile/mandates/authenticate';
        let payload = JSON.stringify({
            mandate_id: mandateList.mandate_id
        });
        OrderAPIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                _openMandateUrl(response.authentication_url);
            } else {
                if (response.status_code === 401) {
                    setTimeout(() => {
                        _redirectUser();
                    }, 3000);
                }
                toast.error(response.message, {
                    type: 'error'
                })
                setButtonLoader(false);
            }

        });
    }

    // inline component to show label value pair 
    function LabelValuePair({ label, value, post_fix, amount }) {
        return (
            <p className={"color-outer-space e-poppins-medium e-font-14"}>
                <label className="color-gray me-2">{label}: </label>
                {
                    amount === true ?
                        <span className="e-inter-medium">{`₹${value.toLocaleString('en-IN')}`}</span>
                        :
                        value
                }
                {
                    post_fix && (
                        <span className="color-outer-space e-poppins-regular e-font-12">({post_fix})</span>
                    )
                }
            </p>
        )
    }

    // Mandate card 
    function MandateCard({ data }) {
        return (
            <div className="border-bright-gray border-all border-radius-16px p-4">
                <div className="row border-bottom gx-0 pb-3">
                    <div className="col-md-6 col-12 d-flex">
                        <div className="bg-white border-bright-gray border-all border-radius-8px w-52px h-52px padding-6px-all me-3">
                            <img src={data.bank_icon}
                                alt={data.bank_name}
                                width={52}
                                height={52}
                                className="object-fit-contain" />
                        </div>
                        <div className="mt-2">
                            <h4 className="color-black e-poppins-medium e-font-16 mt-3">{data?.bank_name}</h4>
                        </div>
                    </div>

                    <div className="col-md-6 text-md-end text-start">
                        <p className="color-light-black e-inter-medium e-font-24-sm-16">
                            <span className="color-gray e-poppins-medium e-font-14">Mandate limit: </span>
                            {`₹${data?.mandate_limit.toLocaleString('en-IN')}`}
                        </p>
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-lg-4 col-md-6 col-12">
                        <LabelValuePair label="Mandate Id"
                            value={data?.mandate_id} />
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                        <LabelValuePair label="Mandate status"
                            value={data?.status} />
                    </div>

                    <div className="col-lg-4 col-md-6 col-12">
                        <LabelValuePair label="Expiry date"
                            value={data?.end_date} />
                    </div>

                    <div className="col-lg-4 col-md-6 col-12">
                        <LabelValuePair label="Created by"
                            value={data.created_by}
                            post_fix={data.admin_type} />
                    </div>
                    <div className="col-lg-8 col-md-6 col-12">
                        <LabelValuePair label="Created on"
                            value={data.created} />
                    </div>
                </div>
                <div className="row">
                    {
                        mandateType === 1 ?
                            <div className="col-lg-4 col-md-6 col-12 mt-2">
                                <GradientButton label="Verify & Approve mandate"
                                    loading={buttonLoader}
                                    className="padding-14px-tb padding-16px-lr"
                                    handleClick={_authMandate} />
                            </div>
                            :
                            <div className="col-lg-4 col-md-6 col-12 mt-2">
                                <GradientButton label="Download "
                                    loading={buttonLoader}
                                    className="padding-14px-tb padding-16px-lr"
                                    handleClick={_authMandate} />
                            </div>
                    }

                </div>

            </div>
        )
    };

    function _handleMandateUploadButton(id) {
        setSelectedMandate(id);
        setOpenUploadDocModal(true);
    };


    function _updateMandateStatus(file) {
        setOpenUploadDocModal(false);
        setSelectedMandate("");
        _getMandates();
        // _submitFile(file);
    };

  



    function _downloadMandate(id) {
        let url = 'profile/v2/mandates/re-download';
        let payload = JSON.stringify({
            mandate_id: id
        });
        OrderAPIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                _fileDownloader(response.data.url, 'Mandate form');
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
        })
    };

    function _fileDownloader(url, file_name) {
        const link = document.createElement('a');
        link.href = url;
        link.download = file_name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <>
            {
                apiLoader === true ? (
                    <div className="container h-100vh padding-64px-lr">
                        <CustomLoader />
                    </div>
                ) : (
                    <>
                        {
                            showInvalidUserScreen === false ? (
                                <>
                                    <div className="container h-100vh ">
                                        {/* Header */}
                                        <div className="row mt-4">
                                            <div className="col-12 text-center">
                                                <img src={darkMode === true ? require("../../Assets/Images/mt-wealth-logo-light.svg").default : require('../../Assets/Images/master-trust-logo.svg').default}
                                                    alt="mt wealth - powered by Master Trust" />
                                            </div>
                                        </div>

                                        {/* Body  */}
                                        <div className="row">
                                            <div className="col-12 mb-3 mt-3">
                                                <h2 className="color-black e-poppins-medium e-font-20">
                                                    Pending mandate
                                                </h2>
                                            </div>

                                            <div className="col-12">
                                                <CustomTab data={MANDATE_TYPE}
                                                    wrapperClass={'gap-16px'}
                                                    selectedTab={mandateType}
                                                    className="px-0 padding-10px-tb e-order-tab mb-lg-4 mb-md-4 mb-3"
                                                    onSelectTab={_handleMandateType} />
                                            </div>

                                            {/* List mandate */}
                                            <div className="col-12">
                                                {mandateType === 1 ?

                                                    mandateList &&
                                                    Object.keys(mandateList).length > 0 && (
                                                        <MandateCard data={mandateList} />
                                                    )


                                                    :
                                                    <>
                                                        {

                                                            <div className="row mt-lg-0 mt-md-0 mt-3">
                                                                {/* <div className="col-12 ">
                                                                    <h6 className="e-poppins-medium e-font-16 color-jett-black">Added physical mandate</h6>
                                                                </div> */}
                                                                {

                                                                    <div className="col-12 mt-3">

                                                                        <div className="border-all border-bright-gray border-radius-16px  overflow-hidden">
                                                                            <div className="row gx-0 row-gap-3 pb-3 border-bottom bg-sidebar padding-16px-lr pt-3 ">
                                                                                <div className="col-lg-3 col-md-4 col-6 col-12">
                                                                                    <div className="d-flex align-items-center gap-12px  ">
                                                                                        <div className="p-2 border-radius-8px border-all border-bright-gray e-bank-image">
                                                                                            <img src={physicalMandate.bank_icon}
                                                                                                alt={physicalMandate.bank_name}
                                                                                                width={28}
                                                                                                height={28}
                                                                                                className="object-fit-contain" />
                                                                                        </div>
                                                                                        <p className="e-poppins-medium e-font-14 color-black mb-0">{physicalMandate.bank_name}</p>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg col-md-4 col-6">
                                                                                    <label className="e-poppins-medium e-font-14 color-outer-space">Account holder name</label>
                                                                                    <p className="e-poppins-medium e-font-14 color-black mb-0">{physicalMandate.account_holder_name}</p>
                                                                                </div>
                                                                                <div className="col-lg col-md-4 col-6">
                                                                                    <label className="e-poppins-medium e-font-14 color-outer-space">Account number</label>
                                                                                    <p className="e-poppins-medium e-font-14 color-black mb-0">{physicalMandate.account_number}</p>
                                                                                </div>
                                                                                <div className="col-lg col-md-4 col-6">
                                                                                    <label className="e-poppins-medium e-font-14 color-outer-space">Account Type</label>
                                                                                    <p className="e-poppins-medium e-font-14 color-black mb-0">{physicalMandate.account_type_label}</p>
                                                                                </div>
                                                                                <div className="col-lg col-md-4 col-6">
                                                                                    <label className="e-poppins-medium e-font-14 color-outer-space">IFSC Code</label>
                                                                                    <p className="e-poppins-medium e-font-14 color-black mb-0">{physicalMandate.ifsc_code}</p>
                                                                                </div>
                                                                            </div>
                                                                            {

                                                                                <div className="border-bottom padding-16px-lr" >
                                                                                    <div className="row">
                                                                                        <div className="col-lg col-md-4 col-6 border-lg-right-1px pt-3 pe-4">
                                                                                            <label className="e-poppins-medium e-font-14 color-outer-space">Added on</label>
                                                                                            <p className="e-poppins-medium e-font-14 color-black">{physicalMandate.created}</p>
                                                                                        </div>
                                                                                        <div className="col-lg col-md-4 col-6 border-lg-right-1px pt-3 pe-4">
                                                                                            <label className="e-poppins-medium e-font-14 color-outer-space">End date</label>
                                                                                            <p className="e-poppins-medium e-font-14 color-black">{physicalMandate.end_date}</p>
                                                                                        </div>
                                                                                        <div className="col-lg col-md-4 col-6 border-lg-right-1px pt-3 pe-4">
                                                                                            <label className="e-poppins-medium e-font-14 color-outer-space">Mandate reg. no</label>
                                                                                            <p className="e-poppins-medium e-font-14 color-black">{physicalMandate.mandate_id}</p>
                                                                                        </div>
                                                                                        <div className="col-lg col-md-4 col-6 border-lg-right-1px pt-3 pe-4">
                                                                                            <label className="e-poppins-medium e-font-14 color-outer-space">Remarks</label>
                                                                                            <p className="e-poppins-medium e-font-14 color-black">{physicalMandate.remarks ? physicalMandate.remarks : '-'}</p>
                                                                                        </div>
                                                                                        <div className="col-lg col-md-4 col-6 border-lg-right-1px pt-3 pe-4">
                                                                                            <label className={`e-poppins-medium e-font-14 color-outer-space`}>Mandate limit</label>
                                                                                            <p className={`e-poppins-medium e-font-14 color-black`}>
                                                                                                <span className="e-inter-medium me-1">₹</span>
                                                                                                {physicalMandate.mandate_limit?.toLocaleString('en-IN')}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="col-lg col-md-4 col-6 border-lg-right-1px pt-3 pe-4">
                                                                                            <label className={`e-poppins-medium e-font-14 color-outer-space`}>Status</label>
                                                                                            <p className={`e-poppins-medium e-font-14 mb-md-0 ${physicalMandate.status_str === 'SUCCESS' ? 'color-sea-green' : physicalMandate.status_str === 'FAILED' ? 'color-red' : 'color-yellow-orange'}`}>{physicalMandate.status_str}</p>
                                                                                        </div>

                                                                                        <div className="col-lg-3 col-md-6 col-sm-6 col-12 pt-3 mb-sm-0 mb-3">
                                                                                            <div className="d-flex flex-column gap-2">

                                                                                                {/* Upload Button */}
                                                                                                <button
                                                                                                    className={`
                                                                                                       ${physicalMandate.is_uploaded === false && physicalMandate.status_str !== "REJECTED"
                                                                                                            ? "border-primary-color cursor-pointer color-primary-color-theme-white"
                                                                                                            : "color-old-silver border-old-silver e-pointer-events-none"}
                                                                                                              bg-cards border-all     border-radius-8px     e-poppins-medium     e-font-14     d-flex     align-items-center     justify-content-center     w-100     mandate-btn `}
                                                                                                    onClick={() => _handleMandateUploadButton(physicalMandate.mandate_id)}
                                                                                                >
                                                                                                    <Icon
                                                                                                        icon="cloud-upload"
                                                                                                        color={
                                                                                                            physicalMandate.is_uploaded === false
                                                                                                                ? darkMode === true
                                                                                                                    ? Color.white
                                                                                                                    : Color.primary
                                                                                                                : Color.old_sliver
                                                                                                        }
                                                                                                        size={18}
                                                                                                        className="me-1"
                                                                                                    />
                                                                                                    Upload
                                                                                                </button>

                                                                                                {/* Download / Re-download Button */}
                                                                                                <GradientButton
                                                                                                    label={
                                                                                                        physicalMandate.is_downloaded === false
                                                                                                            ? "Download"
                                                                                                            : "Re-download form"
                                                                                                    }
                                                                                                    loading={buttonLoader}
                                                                                                    disabled={
                                                                                                        physicalMandate.is_uploaded === true ||
                                                                                                        physicalMandate.status_str === "REJECTED"
                                                                                                    }
                                                                                                    className="w-100 mandate-btn"
                                                                                                    handleClick={() => _downloadMandate(physicalMandate.mandate_id)}
                                                                                                />

                                                                                            </div>
                                                                                        </div>

                                                                                    </div>
                                                                                    {
                                                                                        physicalMandate.is_uploaded === false &&
                                                                                        <div className="row mt-lg-0 mt-3">
                                                                                            <div className="col-12 mb-3">
                                                                                                <div className="d-md-flex align-items-center justify-content-start">
                                                                                                    <div className="d-flex me-sm-3 align-items-center gap-8px bg-mint-cream p-2 border-radius-8px">
                                                                                                        <div className="w-max-content">
                                                                                                            <Icon icon="info"
                                                                                                                size={24} />
                                                                                                        </div>
                                                                                                        <p className="e-font-16 e-poppins-regular line-height-24px color-jett-black mb-0 ">
                                                                                                            {`You can upload your signed document on or before ${physicalMandate.start_date}`}
                                                                                                        </p>
                                                                                                    </div>

                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    }

                                                                                    {
                                                                                        (physicalMandate.is_uploaded === true && physicalMandate.status === true && physicalMandate.status_str === 'PENDING') &&
                                                                                        <div className="d-flex gap-8px bg-pale-sky-blue border-radius-32px p-4 my-3">
                                                                                            <div className="w-max-content">
                                                                                                <Icon icon="info"
                                                                                                    size={30} />
                                                                                            </div>
                                                                                            <div >
                                                                                                <h6 className="e-poppins-medium e-font-16 color-black">Your physical mandate is under review</h6>
                                                                                                <p className="e-font-16 e-poppins-regular line-height-24px color-outer-space mb-0 ">In case of fund transfer via Net Banking, payment confirmation may take some time due to Clearing Corporation fund received. Fund transfer via UPI is instant</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    }
                                                                                </div>


                                                                                // <div className="col-12 mb-4">
                                                                                //     <EmptyScreen image={NoDataMandate}
                                                                                //         title="No Physical mandate found"
                                                                                //         description={''}
                                                                                //         marginClass="mt-sm-0 mt-4"
                                                                                //         imageClass="w-105px"
                                                                                //         secondary={true}
                                                                                //         buttonLabel="Create physical mandate"
                                                                                //         disabled={USER_DATA.is_kyc_done === false ? true : false}
                                                                                //         onPress={() => _showMandateModal(item.bank_id)} />
                                                                                // </div>
                                                                            }
                                                                            {/* {
                                                                                        item.mandates.length ?
                                                                                            <div className="row py-4 padding-16px-lr">
                                                                                                <div className="col text-center">
                                                                                                    <OutlineButton label="Create new mandate"
                                                                                                        disabled={!item.can_create}
                                                                                                        className={`padding-8px-tb padding-16px-lr`}
                                                                                                        handleClick={(e) => _showMandateModal(item.bank_id)} />
                                                                                                </div>
                                                                                            </div>
                                                                                            :
                                                                                            null
                                                                                    } */}
                                                                        </div>


                                                                    </div>
                                                                    // )
                                                                    // })
                                                                }

                                                            </div>
                                                        }
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    {/* Footer */}
                                    <Footer />
                                </>

                            ) : (
                                <div className="container-fluid h-100vh">
                                    <div className="d-flex justify-content-center align-items-center h-100">
                                        <div className="e-card-401 w-400px border-radius-16px p-4 text-center">
                                            <img src={require('../../Assets/Images/no-transactions.jpg')}
                                                alt="404"
                                                width={200}
                                                height={200} />
                                            <h4>{invalidScreenTitle}</h4>
                                            <p>{invalidScreenDesc}</p>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </>
                )
            }

            {
                openUploadDocModal === true && (
                    <UploadSignedMandate close={() => setOpenUploadDocModal(false)}
                        isPublicStack={true}
                        mandateId={selectedMandate}
                        updateMandateStatus={_updateMandateStatus} />
                )
            }
        </>
    );
};